import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingIndicator from "layout/components/Loading";
import Table from "components/table/Table";
import { columnVisibilityItems } from "./components/columnVisibilityItems";
import { TableColumns } from "./components/TableColumns";
import HandleCreateRole from "./HandleCreateRole";
import { AddButton, SmallScreenModel } from "components";
import { fetchAllRoles } from "../store/action";
import { useUser } from "utils/helpers/UserContext";
import { Authorities } from "props/authoritries";
import { SuperAdminStatusEnum } from '../../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const RoleTable: React.FC<Props> = ({ onFetchRoles, fetchAllRoles }) => {
    const { authUser, action, superAdmin } = useUser();
  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  useEffect(() => {
    onFetchRoles();
  }, [onFetchRoles]);
  const { isLoading, roles } = fetchAllRoles;
  const currentRoles = roles;
  if (isLoading) {
    return <LoadingIndicator />;
  }
  const isPermitted =
      authUser &&
      (superAdmin === SuperAdminStatusEnum.SuperAdmin ||
        action?.includes(Authorities.CREATE_CMS_ROLE));
  return (
    <div className="">
      <Table
        headers={["System Setup", "System Roles"]}
        data={currentRoles}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <>
            {isPermitted && (
                <AddButton
                  onClick={openModal}
                  label="Add Role"
                  tooltip="Add new role"
                />
              )}
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <div className="text-center">
          <HandleCreateRole closeModal={closeModal} />
        </div>
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    fetchAllRoles: state.roles?.fetchRolesState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchRoles: () => dispatch(fetchAllRoles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleTable);
